





















import Vue from 'vue'
import * as echarts from 'echarts'
import EchartsTem from './EchartsTem'
export default Vue.extend({
  props: {
    data: { type: Array },
    typeStr: { type: String }
  },
  data() {
    return {
      isFull: false
    }
  },
  watch: {
    data(val) {
      this.echarts()
    }
  },
  mounted() {
    this.echarts()
  },
  methods: {
    echarts() {
      const dom: any = document.getElementById('echartsTem')
      const myChart: any = echarts.init(dom) // 基于准备好的dom，初始化echarts实例
      window.onresize = myChart.resize;  // 图表宽度自适应
      //@ts-ignore
      myChart.setOption(EchartsTem(this.data,''))
    },
    fullScreen() {
      this.isFull = true;
      let fullEchart = document.getElementById('full');
      const myChart: any = echarts.init(fullEchart) // 基于准备好的dom，初始化echarts实例
      window.onresize = myChart.resize;  // 图表宽度自适应
      //@ts-ignore
      myChart.setOption(EchartsTem(this.data,'full'))
    },
    exitFullScreen() {
      this.isFull = false
    }

  }
})
